/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminUavPlatform
 */
export interface InputAdminUavPlatform {
    /**
     * Aliases — допоміжні назви платформи (кожен елемент max 255). Нормалізація (trim,
     * відкидання порожніх, дедуп) — у хендлері перед збереженням.
     * @type {Array<string>}
     * @memberof InputAdminUavPlatform
     */
    aliases?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqControlMaxMhz?: number;
    /**
     * Частоти — діапазон: *Mhz нижня межа, *MaxMhz верхня (не менша за нижню; перевірка
     * у хендлері, бо validator не порівнює вказівники між полями). Порожня верхня = одна частота.
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqControlMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqVideoMaxMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqVideoMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    maxDurationMin?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    speedKmh?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    type: InputAdminUavPlatformTypeEnum;
}


/**
 * @export
 */
export const InputAdminUavPlatformTypeEnum = {
    Recon: 'recon',
    Bomber: 'bomber',
    Kamikaze: 'kamikaze'
} as const;
export type InputAdminUavPlatformTypeEnum = typeof InputAdminUavPlatformTypeEnum[keyof typeof InputAdminUavPlatformTypeEnum];


/**
 * Check if a given object implements the InputAdminUavPlatform interface.
 */
export function instanceOfInputAdminUavPlatform(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputAdminUavPlatformFromJSON(json: any): InputAdminUavPlatform {
    return InputAdminUavPlatformFromJSONTyped(json, false);
}

export function InputAdminUavPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminUavPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'description': json['description'] == null ? undefined : json['description'],
        'freqControlMaxMhz': json['freqControlMaxMhz'] == null ? undefined : json['freqControlMaxMhz'],
        'freqControlMhz': json['freqControlMhz'] == null ? undefined : json['freqControlMhz'],
        'freqVideoMaxMhz': json['freqVideoMaxMhz'] == null ? undefined : json['freqVideoMaxMhz'],
        'freqVideoMhz': json['freqVideoMhz'] == null ? undefined : json['freqVideoMhz'],
        'maxDurationMin': json['maxDurationMin'] == null ? undefined : json['maxDurationMin'],
        'name': json['name'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'type': json['type'],
    };
}

export function InputAdminUavPlatformToJSON(value?: InputAdminUavPlatform | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aliases': value['aliases'],
        'description': value['description'],
        'freqControlMaxMhz': value['freqControlMaxMhz'],
        'freqControlMhz': value['freqControlMhz'],
        'freqVideoMaxMhz': value['freqVideoMaxMhz'],
        'freqVideoMhz': value['freqVideoMhz'],
        'maxDurationMin': value['maxDurationMin'],
        'name': value['name'],
        'speedKmh': value['speedKmh'],
        'type': value['type'],
    };
}

